export default "__VITE_ASSET__72d9444f__"